import {
  ModalBody as ChakraModalBody,
  ModalBodyProps
} from "@chakra-ui/react";
import React from "react";

export const ModalBody = (props: ModalBodyProps) => {
  return <ChakraModalBody {...props} />;
};
